import { IKeyPoints } from 'partner360/models/qbr/IQBRKeyPoints'

import { IHighlightData } from '../models/iHighlightData'

export const mapKeyPointsToHighlightData = (rawData: IKeyPoints): IHighlightData => {
  return {
    caption: rawData.Caption,
    description: rawData.Description,
    isKI: !rawData.Value.includes('%'),
    order: rawData.Order,
    type: rawData.Type,
    value: rawData.Value,
  }
}
